import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import persistStore from '_shared/middleware/persistStore';
import rootReducer from '_shared/reducers';
import {injectStore} from '_shared/lib/action-runner';
import './segment';

let currentStoreState = localStorage.signupFlowState ? JSON.parse(localStorage.signupFlowState) : {};
const store = createStore(rootReducer, currentStoreState, applyMiddleware(thunk, persistStore));
injectStore(store);

import router from './routes';

ReactDOM.render(
  <Provider store={store}>
    {router}
  </Provider>
, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/